import React, { createContext, useContext } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { getTheme } from '../theme';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always dark mode - locked
  const theme = 'dark';
  const isDark = true;

  // Get colors from theme
  const colors = getTheme(isDark);

  // Ant Design theme configuration - always dark
  const antdConfig = {
    algorithm: antdTheme.darkAlgorithm,
    token: {
      colorPrimary: colors.primary,
      colorSuccess: colors.success,
      colorWarning: colors.warning,
      colorError: colors.error,
      colorBgBase: colors.background,
      colorTextBase: colors.text,
      borderRadius: 8,
      fontSize: 14,
    },
  };

  return (
    <ThemeContext.Provider value={{ theme, isDark, colors }}>
      <ConfigProvider theme={antdConfig}>
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
